import { Component, input, output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { CustomFieldsService } from 'src/app/project/modules/custom-fields/custom-fields.service';
import { TValueBreakdownFieldType } from './new-dashlet-modal-value-breakdown-fields-custom-field-picker-consts';

@Component({
    selector: 'pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker-select',
    templateUrl: './new-dashlet-modal-value-breakdown-fields-custom-field-picker-select.component.html',
    styleUrl: './new-dashlet-modal-value-breakdown-fields-custom-field-picker-select.component.scss',
    standalone: false
})
export class NewDashletModalValueBreakdownFieldsCustomFieldPickerSelectComponent {
  ppFieldType = input<TValueBreakdownFieldType>();
  ppFieldId = input<string>();
  ppFieldIdChange = output<string>();
  ppWorkspaceId = input<string>();

  selectedFieldIndex: number;
  filteredCustomFields: TSelectOption[] = [];

  constructor(private customFieldsService: CustomFieldsService) {}

  ngOnChanges(): void {
    this.setFilteredCustomFields();

    this.selectedFieldIndex = this.filteredCustomFields.findIndex(
      (field) => field.value === this.ppFieldId(),
    );
  }

  selectField(field: TSelectOption): void {
    this.ppFieldIdChange.emit(field.value);
  }

  private setFilteredCustomFields(): void {
    if (!this.ppWorkspaceId()) {
      this.filteredCustomFields = [];
      return;
    }

    const customFields = this.customFieldsService.getWorkspaceCustomFields(this.ppWorkspaceId());

    const filteredCustomFields = Object.values(customFields).filter((field) => {
      if (!field.display) {
        return false;
      }

      switch (this.ppFieldType()) {
        case 'list':
          return field.type === ECustomFieldType.LIST;
        case 'numerical':
          return (
            field.type === ECustomFieldType.NUMBERS ||
            field.type === ECustomFieldType.COST ||
            field.type === ECustomFieldType.PERCENTAGE ||
            field.type === ECustomFieldType.FORMULA
          );
      }
    });

    this.filteredCustomFields = filteredCustomFields.map((field) => ({
      label: field.label,
      value: field.id,
    }));
  }
}
